(function ($) {
  function toggleDropdown(event, $toggle) {
    event.preventDefault();
    event.stopPropagation();

    const $li = $toggle.closest('.dropdown');
    const $subnav = $li.children('.dropdown__subnav-wrapper');

    if ($li.hasClass('opened')) {
      $li.removeClass('opened');
      $toggle.attr('aria-expanded', 'false');
      $toggle.find('.toggle-label').text($toggle.attr('data-label-open'));
      $subnav.slideUp('fast');
    } else {
      $li.addClass('opened');
      $toggle.attr('aria-expanded', 'true');
      $toggle.find('.toggle-label').text($toggle.attr('data-label-close'));
      $subnav.slideDown('fast');
    }
  }

  function prepareDropdownForNav($nav) {
    ///// INIT SLIDER POSITION /////
    $nav.find('> .nav-item.active').each(function () {
      const $li = $(this);
      $li.addClass('opened');

      const $toggle = $li.find('> .nav-item__link-wrapper > .dropdown__toggle');
      $toggle.attr('aria-expanded', 'true');
      $toggle.find('.toggle-label').text($toggle.attr('data-label-close'));
    });

    $nav
      .find('> .dropdown')
      .filter(':not(.opened)')
      .each(function () {
        $(this).children('.dropdown__subnav-wrapper').slideUp(0);
      });

    ///// INIT EVENTS /////
    $nav
      .find('> .nav-item > .nav-item__link-wrapper > .dropdown__toggle')
      .on('click', function (event) {
        toggleDropdown(event, $(this));
      });
    $nav
      .find('> .nav-item--heading > .nav-item__link-wrapper > .nav-item__link')
      .on('click', function (event) {
        toggleDropdown(event, $(this).next('.dropdown__toggle'));
      });
  }

  function initMenuMobile() {
    const $mobileMenu = $('.vcc--mobile-menu');
    prepareDropdownForNav($mobileMenu.find('.nav-mobile-main'));
  }

  $(document).ready(function () {
    initMenuMobile();
  });
})(jQuery);
